exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n#previewBox {\n  box-sizing: border-box;\n  position: absolute;\n  margin: 0;\n  padding: 0;\n  background-color: white;\n  border-style: dashed;\n  border-color: #0065B3;\n  z-index: 999;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-389e738a","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/timetable/PreviewBox.vue
// module id = 494
// module chunks = 0